/**
 * G5-T34.3 / G5-T34.6: Embed mod yardımcıları.
 * URL'den ?embed=true&token=<jwt>&theme=dark|light parametrelerini okur.
 */

let _embedToken = null;

/**
 * Uygulamanın embed (iframe) modunda çalışıp çalışmadığını döner.
 */
export function isEmbedMode() {
  return new URLSearchParams(window.location.search).get('embed') === 'true';
}

/**
 * URL'deki ?token= parametresini döner (embed mod için JWT).
 * Token bir kere okunur ve bellekte tutulur.
 */
export function getEmbedToken() {
  if (_embedToken) return _embedToken;
  _embedToken = new URLSearchParams(window.location.search).get('token');
  return _embedToken;
}

/**
 * URL'deki ?theme= parametresini döner ('light' | 'dark', varsayılan 'light').
 */
export function getEmbedTheme() {
  return new URLSearchParams(window.location.search).get('theme') || 'light';
}

/**
 * Temayı DOM'a uygular (data-theme attribute via document root).
 */
export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}
